import { tbColors } from 'styles/colors/tbColors';
import { tbPalette } from './tbPalette';

const text = {
  primary: tbPalette.text.primary,
  disclaimer: tbPalette.text.disclaimer,
  placeholder: tbPalette.text.placeholder,
  positive: tbPalette.text.positive,
  warning: tbPalette.text.warning,
  critical: tbPalette.text.critical,
  highlight: tbPalette.text.highlight,
  body: tbColors.all.ash[900],
};

const ui = {
  default: tbPalette.ui.default,
  positive: tbPalette.ui.positive,
  warning: tbPalette.ui.warning,
  critical: tbPalette.ui.critical,
  highlight: tbPalette.ui.highlight,
  content: tbPalette.ui.content,
};

const surface = {
  default: tbPalette.surface.default,
  positive: tbPalette.surface.positive,
  warning: tbPalette.surface.warning,
  critical: tbPalette.surface.critical,
  highlight: tbPalette.surface.highlight,
  border: tbColors.all.coolGrey[400],
};
const background = {
  default: tbPalette.background.default,
  positive: tbPalette.background.positive,
  warning: tbPalette.background.warning,
  critical: tbPalette.background.critical,
  highlight: tbPalette.background.highlight,
  border: tbColors.all.coolGrey[400],
};
const interactive = {
  ui: {
    default: tbPalette.interactive.ui.default,
    active: tbPalette.interactive.ui.active,
    hover: tbPalette.interactive.ui.hover,
  },
  text: {
    default: tbColors.all.ash[900],
    hover: tbColors.all.ash[900],
    active: tbColors.all.ash[900],
  },
  surface: {
    default: tbPalette.interactive.surface.default,
    hover: tbPalette.interactive.surface.hover,
    active: tbPalette.interactive.surface.active,
    border: {
      default: tbColors.all.coolGrey[400],
      hover: tbColors.all.coolGrey[400],
      active: tbColors.all.coolGrey[400],
      prominent: tbColors.all.coolGrey[400],
    },
  },
  critical: tbPalette.interactive.ui.critical,
  focus: tbPalette.interactive.ui.focus,
  selected: tbPalette.interactive.selected,
};
const dataVisualization = {
  default: tbPalette.data.vis.default,
  positive: tbPalette.data.vis.positive,
  warning: tbPalette.data.vis.warning,
  critical: tbPalette.data.vis.critical,
  border: tbColors.all.coolGrey[400],
  baseline: tbPalette.data.vis.baseline,
  axisText: tbPalette.data.vis.axisText,
  grid: tbPalette.data.vis.grid,
  comparison: tbColors.all.snow[600],
  categories: tbPalette.data.qualitative,
};

export const themePalette = {
  primary: {
    light: tbColors.all.ash[800],
    main: tbColors.all.ash[900],
    dark: tbColors.sharp[900], // default is already our darkest color, so we can use black here
    contrastText: tbPalette.text.inverse,
  },
  secondary: {
    light: tbColors.all.ash[500],
    main: tbColors.all.ash[600],
    dark: tbColors.all.ash[700],
    contrastText: tbColors.all.ash[100],
  },
  text: {
    primary: tbPalette.text.primary,
    secondary: tbPalette.text.secondary,
    disabled: tbPalette.text.disabled,
  },
  success: {
    light: tbColors.all.laurel[400],
    main: tbColors.all.laurel[500],
    dark: tbColors.all.laurel[600],
    contrastText: tbColors.all.ash[900],
  },
  warning: {
    light: tbColors.all.sand[400],
    main: tbPalette.data.vis.warning,
    dark: tbColors.all.sand[600],
    contrastText: tbPalette.text.primary,
  },
  error: {
    light: tbColors.all.coral[400],
    main: tbColors.all.coral[500],
    dark: tbColors.all.coral[600],
    contrastText: tbColors.all.ash[900],
  },
  transparent: tbPalette.transparent,
  semantic: {
    ui,
    text,
    surface,
    background,
    interactive,
    dataVisualization,
  },
};
